import React from "react";
import {
  qhseBg,
  supplyResato8,
  supplyResatoPrez6,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Gas = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Pressure testing: Gas pressure testing" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto ">
          {/* Main Text */}
          <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
            {t("Pressure testing: Gas pressure testing")}
          </p>
          {/* RBS */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Pressure testing: Gas pressure testing")}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("RBS: High pressure gas booster pack")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: Up to 1,300 bar (19.000 psi)")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Flexibility: Portable and easy to move")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Mediums: Suitable for a wide range of gases")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "Portable gas booster pack type RBS is designed to compress gas up to 1300 bar. Not only can it be used to pressurize valves, fittings, hoses, piping, vessels and wellhead equipment, but it is also suitable for gas supply for cylinders, presses and actuators. Compressed air used as a power drive offers advantages over use of other drives. The risk of excessive heat, flame, spark or shock are reduced considerably. The RBS as a standard is available in 8 pressure ranges with a single-acting, double-acting or two-stage gas booster. As an option, the system can be fitted with a chart recorder and a USB data acquisition system. The resulting chart can be used as a test certificate."
                )}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("BOOSTER")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "The unique design high pressure air-driven booster makes the compressor operate at a low noise level. The boosters are used for pressure testing with gases, industrial gas process feeds, gas charging of accumulators and gas bottles, and other applications. The high-pressure seals can be replaced without disassembling the complete booster."
                )}
              </p>

              <a
                href={`${supplyResatoPrez6}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato8}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gas;
